<script setup lang="ts">
import ErrorBoundary from '@/components/ui/ErrorBoundary.vue';
import SessionWatcher from '@/components/ui/SessionWatcher.vue';
import { useScrollRestore } from '@/hooks/useScrollRestore';
import { useSettingsStore } from '@/stores/settings.store';

useScrollRestore();
useSettingsStore();
</script>

<template>
  <ErrorBoundary>
    <SessionWatcher>
      <RouterView />
    </SessionWatcher>
  </ErrorBoundary>
</template>
